import React, { useEffect, useState } from 'react';
import { DEFAULT_CONSULTANT_MODE, getProductBrandForMode } from '../constants';

export default function Logo({ modeId = DEFAULT_CONSULTANT_MODE }) {
  const brand = getProductBrandForMode(modeId);
  const [logoSrc, setLogoSrc] = useState(brand.logo);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setLogoSrc(brand.logo);
    setHasError(false);
  }, [brand.logo]);

  const logoFormats = [
    brand.logo,
    '/branding/legend-sovereign-wordmark-navy.png',
    '/branding/legend-sovereign-stacked-navy.png',
    '/branding/legend-sovereign-logo.png',
  ];

  const handleError = () => {
    const currentIndex = logoFormats.indexOf(logoSrc);
    if (currentIndex < logoFormats.length - 1) {
      setLogoSrc(logoFormats[currentIndex + 1]);
    } else {
      setHasError(true);
    }
  };

  if (hasError) {
    return (
      <div>
        <h1 className="text-xl font-bold tracking-tight text-legend-paper">{brand.productName}</h1>
        <p className="text-[10px] text-legend-slate uppercase tracking-wide">{brand.tagline}</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <img
        src={logoSrc}
        alt={brand.productName}
        className="h-11 sm:h-12 object-contain object-left"
        onError={handleError}
      />
    </div>
  );
}
